// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hilightColor[data-v-2cc4a83e] {\n  color: #653EB3;\n  cursor: pointer;\n}\n.mr5[data-v-2cc4a83e] {\n  margin-right: 5px;\n}\n.mr20[data-v-2cc4a83e] {\n  margin-right: 20px;\n}\n.mb20[data-v-2cc4a83e] {\n  margin-bottom: 20px;\n}\n.mt20[data-v-2cc4a83e] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
